import * as yup from "yup";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import BaseForm from "../../../../../../shared/components/form/BaseForm";
import FormSelect from "../../../../../../shared/components/select/FormSelect";
import { Label } from "../../../../../../shared/components/label/Label";
import { Input } from "../../../../../../shared/components/input/Input";

const EditSubgoalForm = ({ onSubmitHandler, selectables, subgoal }) => {
  const { t } = useTranslation();
  const validationSchema = yup.object({
    dimensionName: yup
      .string()
      .required(
        t("objectivesTracker.editSubgoalForm.fields.dimensionName.required"),
      ),
    dimensionId: yup
      .string()
      .required(
        t("objectivesTracker.editSubgoalForm.fields.dimensionId.required"),
      ),
  });

  const defaultValues = {
    dimensionId: subgoal?.dimension?.id,
    dimensionName: subgoal?.dimension?.name,
    dimensionLabel: subgoal?.dimension?.label,
    dimensionValue: subgoal?.dimension?.value,
  };

  const [parentGoal, setParentGoal] = useState(
    subgoal?.result?.goal / subgoal?.ratio,
  );
  const [ratio, setRatio] = useState(subgoal?.ratio * 100);
  const [goal, setGoal] = useState(subgoal?.result?.goal);

  const onGoalChangeHandler = (e) => {
    const goalToReachValue = +e.target.value;
    const ratioToReachValue = (goalToReachValue / parentGoal) * 100.0;
    setGoal(goalToReachValue);
    setRatio(ratioToReachValue);
  };

  const onRatioChangeHandler = (e) => {
    const ratioToReachValue = +e.target.value;
    const goalToReachValue = (parentGoal * ratioToReachValue) / 100.0;
    setGoal(goalToReachValue);
    setRatio(ratioToReachValue);
  };

  const [dimensions, _] = useState(
    selectables?.map((s) => {
      return { value: s.dimension.value, label: t(s.dimension.label) };
    }),
  );
  const [dimensionValues, setDimensionValues] = useState([]);

  const [dimensionLabel, setDimensionLabel] = useState();
  const [dimensionValue, setDimensionValue] = useState();

  const onDimensionChangeValue = (value) => {
    setDimensionValues(
      selectables?.filter((s) => s.dimension.value === value)[0].values,
    );
    setDimensionLabel(
      t(
        selectables?.filter((s) => s.dimension.value === value)[0].dimension
          .label,
      ),
    );
  };

  const onDimensionValuesChangeValue = (value) => {
    setDimensionValue(
      dimensionValues.filter((dv) => dv.value === value)[0].label,
    );
  };

  const onSubmit = (formValues) => {
    onSubmitHandler({
      ...formValues,
      dimensionValue: dimensionValue,
      dimensionLabel: dimensionLabel,
      ratio: ratio,
    });
  };

  useEffect(() => {
    const dimensionValuesCopy = selectables?.filter(
      (s) => s.dimension.value === subgoal?.dimension?.name,
    )[0].values;
    setDimensionValues(dimensionValuesCopy);
    setDimensionLabel(subgoal?.dimension?.label);
    setDimensionValue(subgoal?.dimension?.value);
  }, []);

  return (
    <BaseForm
      validationSchema={validationSchema}
      defaultValues={defaultValues}
      onSubmitHandler={onSubmit}
    >
      <FormSelect
        name="dimensionName"
        label={t(
          "objectivesTracker.editSubgoalForm.fields.dimensionName.label",
        )}
        options={dimensions}
        placeholder={t(
          "objectivesTracker.editSubgoalForm.fields.dimensionName.placeholder",
        )}
        onValueChangeHandler={onDimensionChangeValue}
        required
      />
      <FormSelect
        name="dimensionId"
        label={t("objectivesTracker.editSubgoalForm.fields.dimensionId.label")}
        options={dimensionValues}
        placeholder={t(
          "objectivesTracker.editSubgoalForm.fields.dimensionId.placeholder",
        )}
        onValueChangeHandler={onDimensionValuesChangeValue}
        required
      />
      <div className="flex flex-row justify-between gap-x-4">
        <div className="w-1/2">
          <Label>
            {t("objectivesTracker.editSubgoalForm.fields.goal.label")}
          </Label>
          <Input type="number" onChange={onGoalChangeHandler} value={goal} />
        </div>
        <div className="w-1/2">
          <Label>
            {t("objectivesTracker.editSubgoalForm.fields.ratio.label")}
          </Label>
          <Input type="number" onChange={onRatioChangeHandler} value={ratio} />
        </div>
      </div>
    </BaseForm>
  );
};

export default EditSubgoalForm;
